export enum WarrantyType {
  FirstAdmissionDate = 'first_admission_date',
  AscriptionDate = 'ascription_date',
  InvoiceDate = 'invoice_date'
}
